// Базовый URL API. 
// В продакшене он должен заменяться на реальный URL через переменные окружения.
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8001/api/landing-sites';

// Текущий slug сайта (можно менять для разных сайтов)
export const SITE_SLUG = import.meta.env.VITE_SITE_SLUG || 'hosting';
